module.exports = __webpack_public_path__ + "img/couple1.8213d315.png";